import { TWITCH_PLAYER_ORIGIN } from "./player-api.js";
import { parseTwitchSource, parseTwitchSource as parseTwitchSource$1, parseTwitchVideoId } from "@videojs/media";
import { isNil, isString } from "@videojs/utils/predicate";
//#region src/source.ts
/**
* Build the iframe `src` URL for an initial Twitch embed from the given props.
*
* @internal
*/
function buildTwitchIframeSrc(src, props = {}) {
	const parsed = parseTwitchSource(src);
	if (!parsed) return "";
	const { parent, referrerPolicy: _referrerPolicy, ...twitch } = props.source?.engine?.twitch ?? {};
	const params = {
		...parsed.kind === "video" ? { video: `v${parsed.id}` } : { channel: parsed.channel },
		controls: props.controls === true ? null : false,
		autoplay: props.autoplay === true ? null : false,
		muted: props.defaultMuted ?? false,
		preload: props.preload ?? "metadata",
		...twitch
	};
	const query = new URLSearchParams();
	for (const key in params) {
		const value = params[key];
		if (isNil(value) || value === "") continue;
		query.set(key, String(value));
	}
	for (const host of resolveParentHosts(parent)) query.append("parent", host);
	return `${TWITCH_PLAYER_ORIGIN}/?${query.toString()}`;
}
/** The configured parent hostnames plus the page's own, deduplicated. */
function resolveParentHosts(parent) {
	const hosts = [...isString(parent) ? [parent] : parent ?? [], globalThis.location?.hostname];
	return [...new Set(hosts.filter((host) => isString(host) && host !== ""))];
}
//#endregion
export { buildTwitchIframeSrc, parseTwitchSource$1 as parseTwitchSource, parseTwitchVideoId };
